<template>
  <div class="com-vide">
    <gkPlayer
      ref="player" 
      :class="['gk-player', 'iconfont']"
    >
    </gkPlayer>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import gkPlayer from 'gkui/player/GkPlayer'
export default {
  name: 'com-vide',
  components: {
    gkPlayer
  },
  props: {
    config: VueTypes.object.def({}),
    url: VueTypes.string.isRequired,
    title: VueTypes.string.def(''),
    poster: VueTypes.string.def('')
  },
  data () {
    return {
      player: null,
      playerInited: false
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
    this.player = this.$refs.player
    this.init()
  },
  methods: {
    init () {
      const source = this.url
      const rate = window.localStorage.getItem('GkPlayerRate') || '1.0'

      this.videoConfig = {
        ...this.config,
        title: this.title,
        source,
        rate,
        autoPlay: false,
        poster: this.poster,
        Hls: window.Hls
      }

      this.$nextTick(() => {
        // 播放器第一次初始化
        if (!this.playerInited) {
          this.player.init(this.videoConfig)
          this.playerInited = true
          this.initVideoEvent()
        }
      })
    },
    initVideoEvent () {
      // this.gkPlayerInited()
      // this.play()
      // this.pause()
      // this.onTimeUpdate()
      // this.playEnd()
      // this.listenFullScreenStatus()
      // this.listenWebFullScreenStatus()
      // this.listenBottomBarShow()
      // this.listenBottomBarHide()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/_common";
@import "../../assets/css/custom.player";

.com-vide {
  height: 409px;
  border-radius: 4px;
  overflow: hidden;

  @include mobile () {
    height: 192px;
  }
}
</style>
